import styled from 'styled-components';
import { rem } from 'polished';

const StyledListFormat = styled.ul`
  align-items: center;
  align-self: bottom;
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
`;

const StyledItem = styled.li`
  margin-left: ${rem('16px')};
  padding: 0;
  &:before {
    display: none;
  }
  &:last-child {
    margin-right: ${rem('8px')};
  }
`;

export { StyledListFormat, StyledItem };
